// widgets/location-popover/ui/LocationAskAddress.tsx

import type { IOrderType } from '@/_store/types';
import { Button } from '@/components/ui/button';
import { HStack, Text, VStack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import React from 'react';

type Props = {
  orderType: IOrderType | null;
  onClose: () => void;
  onOpenSelector: () => void;
};

const AskAddress: React.FC<Props> = ({
  orderType,
  onClose,
  onOpenSelector,
}) => {
  const t = useTranslations();

  return (
    <VStack textAlign='center' gap={0} bg='background.card' color='text'>
      <div>
        <Text fontSize='xl' fontWeight={700} mb={3}>
          {orderType?.type === 'self-pickup'
            ? t('select_branch')
            : t('location.enter_delivery_address')}
        </Text>

        <Text fontSize='xs' maxW='300px' lineHeight={1.2}>
          {orderType?.type === 'self-pickup'
            ? t('location.with_the_branch')
            : t('location.with_the_address')}
        </Text>
      </div>

      <HStack w='full' mt={3}>
        <Button
          flex={1}
          height='48px'
          bgColor='gray.200'
          variant='subtle'
          onClick={onClose}
        >
          {t('location.later')}
        </Button>

        <Button
          flex={1}
          height='48px'
          bg='primary'
          color='primary.text'
          _hover={{ bg: 'primary.hover' }}
          onClick={onOpenSelector}
        >
          OK
        </Button>
      </HStack>
    </VStack>
  );
};

export default AskAddress;
